import { Tooltip, Zoom, IconButton } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';


interface IProps {
    stopPropagation?: boolean
    onClick: () => void
}

let DeleteIconButton = ({ stopPropagation, onClick }: IProps) => {
    return (
        <Tooltip title="Delete" TransitionComponent={Zoom}>
            <IconButton
                size="small"
                color="primary"
                onClick={ev => {
                    if (stopPropagation === true) {
                        ev.stopPropagation();
                    }
                    onClick();
                }}
            >
                <DeleteIcon />
            </IconButton>
        </Tooltip>
    )
}

export default DeleteIconButton;